export enum Actions {
  GET_MOVEMENTS_SUCCESS = 'GET_MOVEMENTS_SUCCESS',
  GET_MOVEMENTS_PENDING = 'GET_MOVEMENTS_PENDING',
  GET_MOVEMENTS_ERROR = 'GET_MOVEMENTS_ERROR',
}
